import React from 'react';
import AuthLoginPage from '../../components/Auth/AuthLoginPage';

const Login = () => (
    <AuthLoginPage
        title="Connexion au Dashboard"
        subtitle="Connectez-vous à votre tableau de bord"
        redirectPath="/dashboard/operations"
        mfaPath="/mfa"
        resetPasswordPath="/admin/reset-password"
        storeEmailOnLogin
    />
);

export default Login;
